import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { useTranslation } from 'react-i18next';

const NetworkIssuePopup = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let data = {
        bg: theme.palette.yellow.bg,
        border: theme.palette.yellow.border,
        icon: <WarningAmberOutlinedIcon />
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1400,
                bgcolor: data.bg,
                color: theme.palette.common.black,
                px: isMobile ? 1 : 3,
                py: 0.8,
                borderRadius: 3,
                border: 1,
                borderColor: data.border,
                boxShadow: theme.shadows[4],
                opacity: 1,
                transition: 'top 0.7s ease-in-out, opacity 0.7s ease-in-out',
                display: 'flex',
                width: isMobile ? '80%' : null
            }}
        >
            {data.icon}
            <Box width={10}> </Box>
            <Typography variant={isMobile ? "body2" : "body1"}>{t('networkIssue')}</Typography>
        </Box>
    );
};

export default NetworkIssuePopup;
